import store from '@store';

export default async (to, from, next) => {
    const allowedRoles = ['member', 'owner'];
    const role = store.getters?.selectedCompany?.company?.role;
    if (role && allowedRoles.includes(role)) {
        next();
    } else {
        // eslint-disable-next-line no-console
        console.appWarn(
            'You do not have sufficient permissions to do that. ' +
                'Please contact to your manager to extend the subscription'
        );
    }
    if (from.name) {
        next(false);
    } else {
        next({ name: 'overview' });
    }
};
